import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import {ProfileFormComponent} from './profile-form.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'profile',
    component: ProfileFormComponent,
    future: true,
    data: {
      pageTitle: 'states.profile.pageTitle',
      breadcrumbTitle: 'states.profile.breadcrumbTitle',
      scopes: ['profile:read']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class ProfileRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/profile/profile.routes.ts